import { toTimestamp } from '../utils/addWebSocketToReplication'
import { toISOString, toISOStringOrNull } from '../utils/pushSafetyUtils'
import { createReplication } from './createReplication'
import type { WorkItemTypeCollection } from '../index'

export const setupWorkItemTypeReplication = (
  collection: WorkItemTypeCollection,
  envId: string,
) =>
  createReplication({
    entityName: 'workitemtypes',
    displayName: 'WorkItemType',
    collection,
    envId,
    apiEntityName: 'work-item-types',
    mapFromServer: (doc) => ({
      id: doc.id,
      envId: doc.envId,
      name: doc.name,
      icon: doc.icon || '',
      color: doc.color || '#3b82f6',
      description: doc.description || '',
      sortOrder: doc.sortOrder ?? null,
      projectIds: doc.projectIds || [],
      isSystem: doc.isSystem || false,
      isDeleted: doc.isDeleted || false,
      createdOn: toTimestamp(doc.createdOn) ?? new Date(doc.createdOn).getTime(),
      createdBy: doc.createdBy,
      updatedOn: toTimestamp(doc.updatedOn) ?? new Date(doc.updatedOn).getTime(),
      updatedBy: doc.updatedBy,
      deletedOn: doc.deletedOn ? (toTimestamp(doc.deletedOn) ?? new Date(doc.deletedOn).getTime()) : null,
      deletedBy: doc.deletedBy,
    }),
    mapToServer: (state, envId) => ({
      id: state.id,
      envId,
      name: state.name,
      icon: state.icon,
      color: state.color,
      description: state.description,
      sortOrder: state.sortOrder ?? null,
      projectIds: state.projectIds,
      isSystem: state.isSystem,
      isDeleted: state.isDeleted,
      createdOn: toISOString(state.createdOn),
      createdBy: state.createdBy,
      updatedOn: toISOString(state.updatedOn),
      updatedBy: state.updatedBy,
      deletedOn: toISOStringOrNull(state.deletedOn),
      deletedBy: state.deletedBy,
    }),
  })
